import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "portal_token";

/** The vendor / client portal talks to the server with its own token, kept apart from the company sign-in. */
export const portalApi = axios.create({ baseURL: `${BACKEND_URL}/api/v1` });

export const getPortalToken = () => localStorage.getItem(TOKEN_KEY);
export function setPortalToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

portalApi.interceptors.request.use((config) => {
  const token = getPortalToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

portalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const path = window.location.pathname;
    if (error?.response?.status === 401 && !path.startsWith("/portal/login") && !path.startsWith("/portal/accept")) {
      setPortalToken(null);
      window.location.href = "/portal/login";
    }
    return Promise.reject(error);
  },
);
